import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order_list",
  "use": "icon-order_list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-order_list\"><path d=\"M736 32H224C169.6 32 128 73.6 128 128v768c0 54.4 41.6 96 96 96h576c54.4 0 96-41.6 96-96V192c0-89.6-70.4-160-160-160zM304 256h192c19.2 0 32 12.8 32 32s-12.8 32-32 32h-192c-19.2 0-32-12.8-32-32s12.8-32 32-32z m416 512h-416c-19.2 0-32-12.8-32-32s12.8-32 32-32h416c19.2 0 32 12.8 32 32s-12.8 32-32 32z m0-224h-416c-19.2 0-32-12.8-32-32s12.8-32 32-32h416c19.2 0 32 12.8 32 32s-12.8 32-32 32z\" p-id=\"10212\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol